import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Mock4allInputComponent } from './mock4all-input/mock4all-input.component';
import { PermissionModule } from "libraries/permission/permission.module";
import { FormsModule } from "@angular/forms";

@NgModule({
    declarations: [
        Mock4allInputComponent
    ],
    entryComponents: [
        Mock4allInputComponent
    ],
    exports: [
        Mock4allInputComponent
    ],
    imports: [
        CommonModule,
        PermissionModule,
        FormsModule,
    ]
})
export class Mock4allModule { }
